import classNames from 'classnames';
import Image from 'next/image';

import {
  NextImageMods,
  NextImageProps,
} from '~components/NextImage/NextImage.types';

import styles from './NextImage.module.scss';

// Компонент используется только если ширина и высота контейнера известна заранее
// Оптимизирует изображения, улучшает CLS-метрику, использует lazy loading
export const NextImage = ({
  className,
  classNameInner,
  alt = '',
  mods,
  strapiSource,
  ...image
}: NextImageProps) => {
  return (
    <div
      className={classNames(
        styles.image,
        className,
        mods?.map((mod) => styles[mod]),
      )}
    >
      <Image
        fill
        loading="lazy"
        style={{
          objectFit: mods?.includes(NextImageMods.FitContain)
            ? 'contain'
            : 'cover',
        }}
        alt={alt}
        className={classNameInner}
        data-strapi-source={strapiSource}
        {...image}
      />
    </div>
  );
};
